import { Injectable } from '@angular/core';

/** Compra que otra pantalla deja pedida para «Mejora tu Fina». */
export interface ImproveFinaIntent {
    /** Cupos de usuario a precargar en el carrito. */
    extraUsers: number;
    /** Abrir el modal de pago en cuanto se pueda. */
    openPayment: boolean;
}

/**
 * Pasa la intención en memoria, no por la URL: un enlace externo no puede precargar cupos
 * ni abrir el pago, y la ruta sin query la sigue validando `PermissionsGuard`.
 * Se consume una sola vez; recargar la página la pierde a propósito.
 */
@Injectable({ providedIn: 'root' })
export class ImproveFinaIntentService {
    private pending: ImproveFinaIntent | null = null;

    request(intent: ImproveFinaIntent): void {
        this.pending = { ...intent };
    }

    consume(): ImproveFinaIntent | null {
        const intent = this.pending;
        this.pending = null;
        return intent;
    }
}
